var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.00015,
    cy: 8.99991,
    r: 7.26923,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.692308
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.65385,
    fill: "white",
    stroke: "#052973",
    strokeWidth: 0.692308
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.00045,
    cy: 8.99996,
    r: 4.84615,
    fill: "#052973"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleIcon2);
export default __webpack_public_path__ + "static/media/circleIcon2.2660c9f1e8b0697e08aa3b72493a9c05.svg";
export { ForwardRef as ReactComponent };